import { ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { LoggingService } from '../../shared/services/core/logging.service';
import { LottoWalletService } from './lotto-wallet.service';

@Injectable({ providedIn: 'root' })
export class LottoWalletResolver {
  constructor(private lottoService: LottoWalletService, private logService: LoggingService) {}

  resolve(route: ActivatedRouteSnapshot) {
    this.logService.info('Resolving lotto wallet items');
    return this.lottoService.fetchLottoWalletItems();
  }
}
